import { render } from "./ModalNewCaseTypeSelect.vue?vue&type=template&id=11f40458&scoped=true"
import script from "./ModalNewCaseTypeSelect.vue?vue&type=script&lang=js"
export * from "./ModalNewCaseTypeSelect.vue?vue&type=script&lang=js"

import "./ModalNewCaseTypeSelect.vue?vue&type=style&index=0&id=11f40458&scoped=true&lang=scss"

import exportComponent from "/home/devops/tool_cases/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11f40458"]])

export default __exports__